function deepFind(data, paramName) {
    if (data == null)
        return null;
    if (Array.isArray(data)) {
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var item = data_1[_i];
            var result = deepFind(item, paramName);
            if (result !== null)
                return result;
        }
        return null;
    }
    if (typeof data === "object") {
        var obj = data;
        if (Object.prototype.hasOwnProperty.call(obj, paramName)) {
            return obj[paramName]; // devuelve tal cual (sin stringify)
        }
        for (var _a = 0, _b = Object.keys(obj); _a < _b.length; _a++) {
            var key = _b[_a];
            var result = deepFind(obj[key], paramName);
            if (result !== null)
                return result;
        }
    }
    return null;
}
/**
 * Busca un parámetro en localStorage con opciones avanzadas
 * @param paramName - Nombre del parámetro a buscar. Si es "", retorna todo el contenido del storage
 * @param storageKey - (Opcional) Nombre específico del localStorage. Si no se proporciona, busca en todos
 * @returns El valor encontrado o null si no existe
 *
 * @example
 * // Buscar 'clientId' en todos los localStorage
 * findParamInLocalStorage<string>('clientId')
 *
 * @example
 * // Obtener todo el contenido de 'afy-action-flags'
 * findParamInLocalStorage('', 'afy-action-flags')
 *
 * @example
 * // Buscar 'userId' solo en 'afy-steps'
 * findParamInLocalStorage<string>('userId', 'afy-steps')
 */
export function findParamInLocalStorage(paramName, storageKey) {
    // Caso 1: Si se especifica un storageKey, buscar solo en ese localStorage
    if (storageKey) {
        try {
            var raw = localStorage.getItem(storageKey);
            if (!raw)
                return null;
            var parsed = JSON.parse(raw);
            // Si paramName está vacío, retornar todo el contenido
            if (paramName === "") {
                return parsed;
            }
            // Buscar el parámetro específico
            var result = deepFind(parsed, paramName);
            if (result !== null && result !== undefined) {
                return result;
            }
        }
        catch (_a) {
            return null;
        }
        return null;
    }
    // Caso 2: Buscar en todos los localStorage
    for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (!key)
            continue;
        try {
            var raw = localStorage.getItem(key);
            if (!raw)
                continue;
            var parsed = JSON.parse(raw);
            // Si paramName está vacío en búsqueda global, saltar (no tiene sentido)
            if (paramName === "")
                continue;
            var result = deepFind(parsed, paramName);
            if (result !== null && result !== undefined) {
                return result;
            }
        }
        catch (_b) {
            continue;
        }
    }
    return null;
}
export var getMetadata = function (pathUrl) {
    var raw = localStorage.getItem("steps");
    if (!raw)
        return null;
    try {
        var steps = JSON.parse(raw);
        if (Array.isArray(steps)) {
            var found = steps.find(function (step) { return (step === null || step === void 0 ? void 0 : step.pathUrl) === pathUrl; });
            if (found && found.metadata !== undefined) {
                return found.metadata;
            }
        }
    }
    catch (_a) {
        return null;
    }
    return null;
};
